/* NEURA MIND landing — behaviors. Scoped to .nm-landing / .nm-sticky. */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var root = document.querySelector(".nm-landing");
    if (!root) return;

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---------- ticker (duplicate content for seamless loop) ---------- */
    var tick = root.querySelector("[data-nm-ticker]");
    if (tick && tick.children.length === 1) {
      tick.appendChild(tick.children[0].cloneNode(true));
    }

    /* ---------- scroll reveals ---------- */
    var revealed = root.querySelectorAll(".nm-rv");
    if ("IntersectionObserver" in window && !reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add("nm-in");
          io.unobserve(e.target);
        });
      }, { threshold: 0.12 });
      revealed.forEach(function (el) { io.observe(el); });
    } else {
      revealed.forEach(function (el) { el.classList.add("nm-in"); });
    }

    /* ---------- chart draw-in ---------- */
    var chart = root.querySelector("[data-nm-chart]");
    if (chart && "IntersectionObserver" in window) {
      var paths = chart.querySelectorAll("[data-nm-line]");
      if (!reduceMotion) {
        paths.forEach(function (p) {
          var L = p.getTotalLength();
          p.style.strokeDasharray = L;
          p.style.strokeDashoffset = L;
        });
        new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            obs.unobserve(chart);
            paths.forEach(function (p, i) {
              p.style.transition = "stroke-dashoffset 1.8s ease " + i * 0.35 + "s";
              requestAnimationFrame(function () { p.style.strokeDashoffset = "0"; });
            });
          });
        }, { threshold: 0.35 }).observe(chart);
      }
    }

    /* ---------- stat count-up ---------- */
    root.querySelectorAll("[data-nm-count]").forEach(function (el) {
      var end = parseInt(el.getAttribute("data-nm-count"), 10);
      if (isNaN(end)) return;
      if (reduceMotion || !("IntersectionObserver" in window)) { el.textContent = end; return; }
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          obs.unobserve(el);
          var t0 = performance.now();
          (function step(t) {
            var k = Math.min((t - t0) / 1300, 1);
            el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3)));
            if (k < 1) requestAnimationFrame(step);
          })(t0);
        });
      }, { threshold: 0.6 }).observe(el);
    });

    /* ---------- dispatch cutoff line (IST) ---------- */
    var dispatchEls = root.querySelectorAll("[data-nm-dispatch]");
    if (dispatchEls.length) {
      var cutoffHour = parseInt(root.getAttribute("data-nm-cutoff") || "16", 10);
      var renderDispatch = function () {
        var now;
        try {
          now = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
        } catch (err) {
          now = new Date();
        }
        var cut = new Date(now);
        cut.setHours(cutoffHour, 0, 0, 0);
        var rest;
        if (now < cut) {
          var mins = Math.floor((cut - now) / 60000);
          var h = Math.floor(mins / 60);
          var m = mins % 60;
          rest = " Order within " + (h > 0 ? h + "h " : "") + m + "m → dispatches tomorrow morning.";
        } else {
          rest = " Order now → dispatches next business morning.";
        }
        dispatchEls.forEach(function (el) {
          el.textContent = "";
          var b = document.createElement("b");
          b.textContent = "In stock.";
          el.appendChild(b);
          el.appendChild(document.createTextNode(rest));
        });
      };
      renderDispatch();
      setInterval(renderDispatch, 30000);
    }

    /* ---------- bundle selector (real variants) ---------- */
    var dataEl = root.querySelector("[data-nm-variants]");
    var form = root.querySelector("form[data-type='add-to-cart-form']");
    var idInput = form ? form.querySelector("input[name='id']") : null;
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    }

    var priceMain = root.querySelector("[data-nm-price]");
    var priceWas = root.querySelector("[data-nm-was]");
    var priceSave = root.querySelector("[data-nm-save]");
    var perDay = root.querySelector("[data-nm-perday]");
    var atcLabel = root.querySelector("[data-nm-atc-label]");
    var stickyPrice = document.querySelector("[data-nm-sticky-price]");
    var buyNowButton = form ? form.querySelector("[data-nm-buy-now]") : null;
    var formErrorWrapper = root.querySelector(".product-form__error-message-wrapper");
    var formErrorMessage = formErrorWrapper ? formErrorWrapper.querySelector(".product-form__error-message") : null;
    var buyNowPending = false;
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";

    function shopRoute(path) {
      return shopRoot + path.replace(/^\//, "");
    }

    function showBuyNowError(message) {
      if (!formErrorWrapper || !formErrorMessage) return;
      formErrorMessage.textContent = message || "";
      formErrorWrapper.hidden = !message;
    }

    function setBuyNowPending(pending) {
      buyNowPending = pending;
      if (!buyNowButton) return;
      if (pending) {
        buyNowButton.setAttribute("disabled", "");
        buyNowButton.setAttribute("aria-busy", "true");
      } else {
        buyNowButton.removeAttribute("disabled");
        buyNowButton.removeAttribute("aria-busy");
      }
    }

    async function submitBuyNow(event) {
      if (!buyNowButton || !idInput || (event.submitter && event.submitter !== buyNowButton)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (buyNowPending) return;

      var variantId = Number(idInput.value);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) {
        showBuyNowError("Please choose an available pack.");
        return;
      }

      showBuyNowError("");
      setBuyNowPending(true);

      try {
        var response = await fetch(shopRoute("cart/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        var payload = null;
        try { payload = await response.json(); } catch (parseError) { payload = null; }

        if (!response.ok) {
          throw new Error(payload && (payload.description || payload.message)
            ? payload.description || payload.message
            : "This pack could not be added. Please try again.");
        }

        window.location.assign(shopRoute("checkout"));
      } catch (error) {
        setBuyNowPending(false);
        showBuyNowError(error && error.message ? error.message : "Checkout could not be opened. Please try again.");
      }
    }

    if (form && buyNowButton) form.addEventListener("submit", submitBuyNow, true);

    function applyVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceMain) priceMain.textContent = v.price_formatted;
      if (priceWas) {
        priceWas.textContent = v.compare_formatted || "";
        priceWas.style.display = v.compare_formatted ? "" : "none";
      }
      if (priceSave) {
        priceSave.textContent = v.save_label || "";
        priceSave.style.display = v.save_label ? "" : "none";
      }
      if (perDay) {
        perDay.textContent = "";
        var lead = document.createElement("b");
        lead.textContent = v.perday_lead || "";
        perDay.appendChild(lead);
        perDay.appendChild(document.createTextNode(v.perday_rest ? " " + v.perday_rest : ""));
      }
      if (atcLabel) atcLabel.textContent = v.available ? "Buy now · " + v.price_formatted : "Sold out";
      if (stickyPrice) stickyPrice.textContent = v.price_formatted + (v.available ? " · in stock" : " · sold out");
      if (buyNowButton) buyNowButton.toggleAttribute("disabled", !v.available || buyNowPending);
    }

    var bundleBtns = root.querySelectorAll(".nm-bundle");
    bundleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        bundleBtns.forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        var v = variants.filter(function (x) { return String(x.id) === btn.getAttribute("data-variant-id"); })[0];
        applyVariant(v);
      });
    });

    /* ---------- secondary CTAs scroll to buy box ---------- */
    var buyBox = root.querySelector("#NmBuy");
    root.querySelectorAll("[data-nm-goto-buy]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        if (btn.tagName === "A") return;
        e.preventDefault();
        if (buyBox) buyBox.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });
      });
    });

    /* ---------- sticky bar ---------- */
    var sticky = document.querySelector(".nm-sticky");
    if (sticky && buyBox && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var below = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle("nm-show", below);
        });
      }, { threshold: 0 }).observe(buyBox);

      var stickyBtn = sticky.querySelector("[data-nm-sticky-atc]");
      if (stickyBtn && form && buyNowButton) {
        stickyBtn.addEventListener("click", function () {
          if (typeof form.requestSubmit === "function") form.requestSubmit(buyNowButton);
          else buyNowButton.click();
        });
      }
    }
  });
})();
